import { Component, inject, OnInit } from '@angular/core';
import { MerchantService } from 'src/app/_services/merchant.service';
import { IntegrationService } from 'src/app/_services/integration.service';

@Component({
    selector: 'app-prod-configurations',
    templateUrl: './prod-configurations.component.html',
    styleUrls: ['./prod-configurations.component.scss'],
    standalone: false
})
export class ProdConfigurationsComponent implements OnInit {
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly integrationService: IntegrationService = inject(IntegrationService);

  ngOnInit(): void {
    this.integrationService.getProductionLicense().subscribe((license: any) =>  this.merchantService.currentProductionMerchant = license.items[0] ? license.items[0] : null);
  }

}
